// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"3e04dd41","453":"419a5d54","626":"73cd86d8"}[chunkId] + ".chunk.js";
};